module.exports = __webpack_public_path__ + "static/sport/bgi-form.5e4c0df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lottery/bgi-form.png
// module id = 42wO
// module chunks = 0